var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.208 18.993C26.208 19.5888 25.9505 20.1602 25.4922 20.5815C25.0339 21.0028 24.4123 21.2395 23.7641 21.2395H4.21337C3.56523 21.2395 2.94363 21.0028 2.48532 20.5815C2.02701 20.1602 1.76953 19.5888 1.76953 18.993V3.26728C1.76953 2.67146 2.02701 2.10005 2.48532 1.67874C2.94363 1.25744 3.56523 1.02075 4.21337 1.02075H10.323L12.7668 4.39054H23.7641C24.4123 4.39054 25.0339 4.62723 25.4922 5.04853C25.9505 5.46984 26.208 6.04125 26.208 6.63707V18.993Z",
    stroke: "#4C6FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file_icon.6882a331e47440c7de2a866473c4f301.svg";
export { ForwardRef as ReactComponent };